/*
 *   File : kyc.js
 *   Author URI : https://evoqins.com
 *   Description : Navigation screen which holds all four steps in the KYC registration flow.
 *   Integrations : null
 *   Version : v1.1
 */
// import package
import { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

// import components
import Icon from "../../Components/Icon/icon";
import { CustomLoader } from "../../Components/Other";
import LandingPage from "./helpers/landing";
import KYCStatusPage from "./helpers/kyc-status";
import PANDetailsPage from "./helpers/pan-detail";
import PersonalDetailsPage from "./helpers/personal-details";
import DeclarationsPage from "./helpers/declaration";
import KYCStatus from "./helpers/status";
import NomineePage from "./helpers/nominee";
import BankDetail from "./helpers/bank";
import PreviewPage from "./helpers/preview"
import CreateBank from "./helpers/create-bank";

import { NavigationHeader } from "../../Components/Header";

import Store from '../../Store';

import Colors from '../../Styles/color.module.scss';
import APIService from "../../Services/api-service";
import UploadDeclaration from "./helpers/declaration-upload";
import MinorPANDetailsPage from "./helpers/minor-pan-detail";
import MinorBankDetail from "./helpers/minor-bank-details";
import { VerifyNRINumber, NRIPANDetailsPage, NRIPersonalDetailsPage, NRIAddressDetailsPage, NRITaxDetailsPage, NRIBankDetail, NriNomineePage, SubmitNRIKyc, NriPreviewPage } from "./helpers/NRI";

const PAGE_NAVIGATION = [
    "Dashboard",
    "Create user account"
]
function KYCPage(props) {
    const location = useLocation();
    console.log('location', location);

    const KYC_DATA = useSelector(state => state.MT_ADMIN_STORE.KYC_DATA);
    console.log('KYC_DATA', KYC_DATA);

    const [progress, setProgress] = useState(1);
    console.log('progress', progress);

    const [backNavigation, setBackNavigation] = useState(false);
    const [ipvLinkStatus, setIpvLinkStatus] = useState(false);
    console.log('ipvLinkStatus', ipvLinkStatus);

    const [loader, setLoader] = useState(true);
    const [accountType, setAccountType] = useState("");
    console.log('accountType', accountType);

    const [submitKycType, setSubmitKycType] = useState(false);
    const [digioToken, setDigioToken] = useState('');


    const [isManual, setIsManual] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    console.log('isEdit', isEdit);
    console.log('isManual', isManual);


    console.log('KYC_STEP', KYC_DATA);

    useEffect(() => {
        if (location.state !== null) {
            _getKycGeneralData();
            _getGeneralData();
            _getKYCData(location.state.user_id);
        }
    }, [location]);

    function _updateProgress(value, text = accountType, is_manual = isManual, is_edit = false,) {
        setProgress(value);
        setAccountType(text);
        if (text !== "Individual") {
            // alert('1');
            setIsManual(true);
        } else {
            setIsManual(false);
        }
    }

    // navigate back to prev kyc step
    function _navigateBack() {
        setProgress(progress - 1);
        setBackNavigation(true);
    }

    // render page based on KYC step
    function _getKYCStep(kyc_data) {
        try {
            console.log('kyc_data.onboarding_sub_type', kyc_data.onboarding_sub_type);

            setAccountType(kyc_data.onboarding_sub_type !== null ? kyc_data.onboarding_sub_type : "")
            if (kyc_data.onboarding_sub_type !== "Individual") {
                // alert('2');
                setIsManual(true);
            } else {
                setIsManual(false);
            }

            if (kyc_data.kyc_step === 0) {
                if (kyc_data.email === null || kyc_data.mobile === null) {
                    setProgress(1);
                }
                else if (kyc_data.email !== null && kyc_data.mobile !== null) {
                    setProgress(2);
                }
                else {
                    setProgress(kyc_data.kyc_step + 1)
                }
            }
            // NRI: stay on submit-kyc (step 9) until IPV/eSign is actually completed,
            // even if the backend has already advanced kyc_step.
            else if (
                kyc_data.onboarding_sub_type === "NRI" &&
                kyc_data.signup_progress_text === "NOMINEE_ADDED"
            ) {
                setProgress(9);
                setLoader(false);
                return;
            }
            else
                if (kyc_data.kyc_step < (kyc_data.onboarding_sub_type !== "Individual" ? 9 : 7)) {
                    if (kyc_data.onboarding_sub_type === "HUF") {
                        if (kyc_data.signup_progress_text === "PAN_ADDED") {
                            setProgress(3);
                        } else if (kyc_data.signup_progress_text === "PERSONAL_DETAILS_ADDED") {
                            setProgress(4);
                        } else if (kyc_data.signup_progress_text === "DECLARATIONS_ADDED") {
                            setProgress(5);
                        } else if (kyc_data.signup_progress_text === "BANK_ADDED") {
                            setProgress(6);
                        } else if (kyc_data.signup_progress_text === "NOMINEE_ADDED") {
                            setProgress(6);
                        } else {
                            setProgress(7);
                        }
                    }
                    else if (kyc_data.onboarding_sub_type === "Minor") {
                        if (kyc_data.signup_progress_text === "PAN_ADDED") {
                            setProgress(3);
                        } else if (kyc_data.signup_progress_text === "DECLARATIONS_ADDED") {
                            setProgress(4);
                        } else if (kyc_data.signup_progress_text === "BANK_ADDED") {
                            setProgress(5);
                        } else if (kyc_data.signup_progress_text === "ESIGN_REQUIRED") {
                            setProgress(5);
                        } else {
                            setProgress(5);
                        }
                    } else if (kyc_data.onboarding_sub_type === "NRI") {
                        if (kyc_data.signup_progress_text === "FOREIGN_NUMBER_ADDED") {
                            setProgress(3)
                        }
                        else if (kyc_data.signup_progress_text === "PAN_ADDED") {
                            setProgress(4);
                        } else if (kyc_data.signup_progress_text === "PERSONAL_DETAILS_ADDED") {
                            setProgress(5);
                        }
                        else if (kyc_data.signup_progress_text === "ADDRESS_ADDED") {
                            setProgress(6);
                        }
                        else if (kyc_data.signup_progress_text === "DECLARATIONS_ADDED") {
                            setProgress(7);
                        }
                        else if (kyc_data.signup_progress_text === "BANK_ADDED") {
                            setProgress(8);
                        }
                        else if (kyc_data.signup_progress_text === "NOMINEE_ADDED") {
                            // if (kyc_data.nri_info.ipv_link_sent === true) {
                            //     setProgress(10);
                            // } else {
                            setProgress(9);
                            // }
                        }
                        // else if (kyc_data.signup_progress_text === (isManual ? "IS_MANUAL_ADDED" : "IPV_ADDED") || kyc_data.signup_progress_text === "ESIGN_REQUIRED") {
                        //     setProgress(10);
                        // }
                        else if (
                            kyc_data.signup_progress_text === "ESIGN_REQUIRED" ||
                            kyc_data.signup_progress_text === "IPV_ADDED"
                        ) {
                            setProgress(10);
                        }
                        else {
                            setProgress(11);
                        }
                    }
                    else {
                        setProgress(kyc_data.kyc_step + 2)
                    }
                }
                else {
                    if (kyc_data.signup_progress_text === "ADMIN_REJECTED" || kyc_data.signup_progress_text === "KYC_REJECTED") {
                        setProgress(2);
                    } else {
                        if (kyc_data.onboarding_sub_type === "NRI") {
                            setProgress(kyc_data.kyc_step + 2)
                        } else {
                            setProgress(kyc_data.kyc_step + 1)
                        }
                    }
                }
            setLoader(false);
        } catch (error) {
            toast.dismiss();
            toast.error(error, {
                type: "error"
            });
        }
    }

    // API for general data
    function _getGeneralData() {
        let url = 'general/get-data';
        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'APP_GENERAL_DATA',
                    payload: response.data
                });
            }
        })
    }

    // API - get kyc general data
    function _getKycGeneralData() {
        let url = 'kyc/general-data';
        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'GET_KYC_FILTERS',
                    payload: response.data
                });
            }
        })
    }

    // get kyc progress data
    function _getKYCData(customer_id) {
        setLoader(true);
        let url = 'onboarding/kyc/detail';
        let payload = JSON.stringify({
            customer_id
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                setIsEdit(response.data.is_review);
                Store.dispatch({
                    type: 'GET_KYC_DATA',
                    payload: response.data
                });
                _getKYCStep(response.data);
            } else {
                toast.error(response.message, {
                    type: 'error'
                })
            }
        })
    }

    function KYCProgress() {
        return (
            <div className={progress > 9 ? "mt-5" : ""}>
                <p className="color-outer-space e-poppins-regular e-font-16 margin-block-end-0 mb-2">{`Step ${progress} of ${accountType == "NRI" ? 10 : accountType === "Minor" ? "5" : accountType === "HUF" ? "7" : "8"}`}</p>
                <div className="d-flex mb-4">
                    {Array.from({ length: accountType === "Minor" ? 5 : accountType === "HUF" ? 7 : accountType === "NRI" ? 10 : 8 }, (_, key) => (
                        <div key={key} className="bg-sliver-gray border-radius-4px position-relative e-kyc-progress-track me-1">
                            <div
                                className="bg-ocean-boat-blue border-radius-4px position-absolute e-kyc-progress-bar top-0 left-0"
                                data-completed-step={progress >= key + 1 ? true : false} // Completed step 
                                data-completing-step={progress === key + 1 && backNavigation === false ? true : false} // next step progress animation
                                data-prev-step={backNavigation && progress === key} // prev step progress animationś
                            ></div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        loader === true ?
            <CustomLoader />
            :
            <Fragment>
                <NavigationHeader type={1}
                    data={PAGE_NAVIGATION}
                    title="Create user account" />
                <div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-32px-top padding-200px-bottom">
                    {
                        progress === 1 ?
                            <div className="row">
                                <div className="col-12">
                                    <LandingPage updateProgress={_updateProgress} />
                                </div>
                            </div>
                            :
                            <div className="row">
                                <div className="col-12">
                                    {
                                        isEdit === false ?
                                            <div className="mt-4 mb-2 py-2">
                                                {(progress > (accountType === "HUF" ? 2 : accountType === "Minor" ? 2 : accountType === "NRI" ? 4 : 3) && progress < (accountType === "Minor" ? 6 : accountType === "HUF" ? 9 : 11)) &&
                                                    <button className="color-black e-poppins-medium e-font-16 e-font-sm-16-14 e-kcy-back-button px-0 bg-transparent no-border no-outline my-sm-4 my-2 py-2 "
                                                        onClick={_navigateBack}>
                                                        <Icon icon="back-arrow"
                                                            size={24}
                                                            className="me-2 e-arrow"
                                                            color={Colors.black} />
                                                        Back to previous step
                                                    </button>}
                                            </div>
                                            :
                                            null
                                    }

                                    {(progress <= (accountType === "Minor" ? 5 : accountType === "HUF" ? 7 : 10) && progress > 1) && <KYCProgress />}

                                    {
                                        progress === 2 ?
                                            accountType === "NRI" ?
                                                <VerifyNRINumber edit={isEdit} updateProgress={_updateProgress} />
                                                :
                                                accountType === "Minor" ?
                                                    <MinorPANDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                    :
                                                    <PANDetailsPage updateProgress={_updateProgress} text={accountType} is_manual={isManual} />

                                            : progress === 3 ?
                                                accountType === "NRI" ?
                                                    <NRIPANDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                    :
                                                    accountType === "Minor" ?
                                                        <DeclarationsPage edit={isEdit} is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                        :
                                                        <KYCStatusPage edit={isEdit} updateProgress={_updateProgress} is_manual={isManual} text={accountType} />

                                                : progress === 4 ?
                                                    accountType === "NRI" ?
                                                        <NRIPersonalDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                        :
                                                        isManual ?
                                                            accountType === "Minor" ?
                                                                <MinorBankDetail edit={isEdit} updateProgress={_updateProgress} is_manual={isManual} text={accountType} />
                                                                :
                                                                <DeclarationsPage edit={isEdit} is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                            :
                                                            <PersonalDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                    : progress === 5 ?
                                                        accountType === "NRI" ?
                                                            <NRIAddressDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                            :
                                                            isManual ?
                                                                accountType === "Minor" ?
                                                                    <PreviewPage is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                                    :
                                                                    <BankDetail edit={isEdit} updateProgress={_updateProgress} is_manual={isManual} text={accountType} />
                                                                :
                                                                <DeclarationsPage edit={isEdit} is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                        :
                                                        accountType === "Minor" ?
                                                            <KYCStatus text={accountType} updateProgress={_updateProgress} />
                                                            :
                                                            progress === 6 ?

                                                                accountType === "NRI" ?
                                                                    <NRITaxDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                                    :
                                                                    isManual ?
                                                                        <UploadDeclaration edit={isEdit} is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                                        :
                                                                        <CreateBank edit={isEdit} updateProgress={_updateProgress} />
                                                                :
                                                                progress === 7 ?
                                                                    accountType === "NRI" ?
                                                                        <NRIBankDetail edit={isEdit} updateProgress={_updateProgress} />
                                                                        :
                                                                        isManual ?
                                                                            <PreviewPage is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                                            :
                                                                            <NomineePage edit={isEdit} updateProgress={_updateProgress} />
                                                                    :
                                                                    progress === 8 ?
                                                                        accountType === "NRI" ?
                                                                            <NriNomineePage edit={isEdit} updateProgress={_updateProgress} />
                                                                            :
                                                                            isManual ?
                                                                                <KYCStatus updateProgress={_updateProgress} text={accountType} />
                                                                                :
                                                                                <PreviewPage is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                                        :
                                                                        progress === 9 ?
                                                                            accountType === "NRI" ?
                                                                                <SubmitNRIKyc edit={isEdit}
                                                                                    back={backNavigation}
                                                                                    // submitKycTypeStatus={submitKycTypeStatus}
                                                                                    // ipvLinkStatus={(status) => setIpvLinkStatus(status)}
                                                                                    updateProgress={_updateProgress}
                                                                                    submitKycType={() => {
                                                                                        setSubmitKycType(true);
                                                                                        setBackNavigation(false);
                                                                                    }} />
                                                                                :
                                                                                accountType === "HUF" ?
                                                                                    <KYCStatus updateProgress={_updateProgress} />
                                                                                    :
                                                                                    <PreviewPage is_manual={isManual} text={accountType} updateProgress={_updateProgress} digioToken={digioToken} />

                                                                            :
                                                                            progress === 10 ?
                                                                                accountType === "NRI" ?
                                                                                    <NriPreviewPage edit={isEdit} accountType={accountType} updateProgress={_updateProgress} />
                                                                                    :
                                                                                    <KYCStatus updateProgress={_updateProgress} />
                                                                                :
                                                                                <KYCStatus updateProgress={_updateProgress} text={accountType} />

                                    }
                                </div>
                            </div>
                    }

                </div>
            </Fragment>
    )
}

export default KYCPage